// eslint-disable-next-line no-unused-vars
import React from 'react';
import { Button } from '@carbon/react';
import styled from '@emotion/styled';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ArrowContainer = styled.div`
  position: absolute;
  z-index: 2;
  top: 50%;
  transform: translateY(-50%);

  button {
    transition: opacity 0.05s;
    opacity: 0.45;
    background-color: rgb(243, 242, 242) !important;
    width: 25px;
    height: 55px;

    &:hover {
      background: #0003;
    }

    svg {
      stroke: rgb(31, 89, 162);
    }
  }

  .cds--popover-content.cds--tooltip-content,
  .cds--popover-caret {
    display: none !important;
  }
`;

const PrevArrowContainer = styled(ArrowContainer)`
  left: 0;
`;

const NextArrowContainer = styled(ArrowContainer)`
  right: 0;
`;

export const renderPrevArrow = (onClickHandler, hasPrev, label) => hasPrev && (
  <PrevArrowContainer>
    <Button
      kind="ghost"
      size="lg"
      hasIconOnly
      renderIcon={ props => <ChevronLeft {...props} size={ 25 } /> }
      aria-label={ label }
      onClick={ onClickHandler }
    />
  </PrevArrowContainer>
);

export const renderNextArrow = (onClickHandler, hasNext, label) => hasNext && (
  <NextArrowContainer>
    <Button
      kind="ghost"
      size="lg"
      hasIconOnly
      renderIcon={ props => <ChevronRight {...props} size={ 25 } /> }
      aria-label={ label }
      onClick={ onClickHandler }
    />
  </NextArrowContainer>
);
